import { prop } from 'ramda';

import { compact } from '../../../../helpers/compact';
import { DocumentType } from '../../../../types/document';
import { processFinancialFooter } from './financial/financial-footer';
import { deprecatedPageEntity } from './internal';

/**
 * @typedef  {Object} PrismicFinancialPressRelease
 */

/**
 * @typedef {DocumentSchema} FinancialPressReleaseSchema
 */

/**
 * Transform the given input into objects
 *
 * @param  {PrismicFinancialPressRelease} data
 * @return {FinancialPressReleaseSchema}
 */
const processFinancialPressRelease = (data) =>
  compact({
    uid: DocumentType.FINANCIAL_PRESS_RELEASE,
    type: DocumentType.FINANCIAL_PRESS_RELEASE,
    ...processFinancialFooter(data),
  });

/**
 * Normalizr schema representing a financial press release page
 */
export const FinancialPressReleaseEntity = deprecatedPageEntity(
  DocumentType.FINANCIAL_PRESS_RELEASE,
  {
    processStrategy: (entity) =>
      processFinancialPressRelease(prop('data', entity)),
  }
);
